import { useEffect, useState } from "react";
import api from "../lib/api";
import { usd } from "../lib/money";

// Owner-only line at the bottom of the studio. Customers get nothing back from the endpoint, so they never see it.
export const StudioGateFooter = () => {
  const [gate, setGate] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/creations/gate-mode")
      .then(({ data }) => alive && data?.mode && setGate(data))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!gate) return null;
  return (
    <p data-testid="studio-gate-mode" className="mt-10 text-center text-xs font-mono2 text-accent-strong">
      Spend gate: {gate.label}
      {gate.paused ? " · PAUSED" : ""} · {usd(gate.spent_usd)} today
      {gate.configured === false ? " · running on defaults" : ""}
    </p>
  );
};
